export var RenderModeEnum;

!function(RenderModeEnum) {
    RenderModeEnum["desktop-browser"] = "desktop-browser", RenderModeEnum["mobile-browser"] = "mobile-browser", 
    RenderModeEnum.node = "node", RenderModeEnum.worker = "worker", RenderModeEnum.miniApp = "miniApp", 
    RenderModeEnum.wx = "wx", RenderModeEnum.tt = "tt", RenderModeEnum.harmony = "harmony", 
    RenderModeEnum["desktop-miniApp"] = "desktop-miniApp", RenderModeEnum.lynx = "lynx";
}(RenderModeEnum || (RenderModeEnum = {}));
//# sourceMappingURL=common.js.map
